import { ModuleLayout } from "../_shared/ModuleLayout";
export default function WorkspaceLayout() {
  return (
    <ModuleLayout
      testId="pureh-ws"
      eyebrow="My Office"
      title="My Office"
      subtitle="Today · Calendar · Approvals · Meetings · Files · Notes · My KPI · My Tasks."
      tabs={[
        { to: "myday",  label: "Today" },
        { to: "tasks",  label: "Tasks" },
        { to: "people", label: "People" },
        { to: "files",  label: "Files" },
        { to: "audit",  label: "Audit Log" },
      ]}
    />
  );
}
